export const SVG_WIDTH = 800
export const SVG_HEIGHT = 800

export const LOGO_WIDTH = 55

// STAT SLIDER
export const RECT_HEIGHT = 16
export const VALUE_FONT_SIZE = 12
export const DEFAULT_WIDTH = 8 // Width of rect for 0%
export const SAVANT_GREEN = '#b2dfdb'
export const LOGO_GREEN = '#399098'
export const DARKER_SAVANT_GREEN = '#2f716b'
export const DARKER_GOLD = '#e7c53a'

export const STAT_HEADER_GAP = 48
export const HEADER_TEXT_HEIGHT = 45
export const SECTION_MARGIN = 2
export const LEFT_SIDE_BUFFER = 70

// PLAYER COMPONENT
export const TOP_BUFFER = 120
export const LINE_HEIGHT = RECT_HEIGHT + 4
export const LINE_OFFSET = LINE_HEIGHT - RECT_HEIGHT
export const FONT_SIZE = 12
export const SIDE_BUFFER = 10
export const RIGHT_SIDE_BUFFER = 30

export const SLIDER_OFFSET_FROM_TEXT = 100
export const TEXT_RIGHT_SIDE = 90
export const TEXT_Y_OFFSET = (RECT_HEIGHT - FONT_SIZE) / 2

export const BETWEEN_PLAYERS_BUFFER = 10
export const MAX_FULL_PLAYERS = 5
export const MAX_TOTAL_PLAYERS = 9

// PLAYER HEADER
export const IMG_WIDTH = 80
export const IMG_TOP_BUFFER = 20
export const BTWN_PAN_BUFFER = 5
export const TITLE_TOP_BUFFER = 15
export const NAME_TEXT_TOP_OFFSET = 6
export const NAME_TEXT_OFFSET = 14
export const YEAR_TEXT_OFFSET = 15
export const TEAM_LOGO_OFFSET = 14

export const MAX_SLIDER_WIDTH =
    (SVG_WIDTH -
        LEFT_SIDE_BUFFER -
        SLIDER_OFFSET_FROM_TEXT -
        SIDE_BUFFER -
        RIGHT_SIDE_BUFFER) /
        MAX_FULL_PLAYERS -
    BETWEEN_PLAYERS_BUFFER // Width of rect for 100% plus buffer

export const OHTANI = 660271

// PLAYER SEARCH
export const SEARCH_PLAYER_STAGING_HEIGHT = 100
export const SEARCH_PLAYER_COMPONENT_WIDTH = 80
export const SEARCH_PLAYER_COMPONENT_BUFFER = 5
export const SEARCH_PLAYER_COMPONENT_HEIGHT =
    SEARCH_PLAYER_STAGING_HEIGHT - 2 * SEARCH_PLAYER_COMPONENT_BUFFER

export const VALUE_WIDTH = 30
export const VALUE_BUFFER = 5

export const ADD_STAT_BUTTON_DIM = 24
export const TITLE_HEIGHT = 22

// STAT SELECT
// export const STAT_DRAG_RECT_WIDTH = 176
// export const REMOVE_BUTTON_X = STAT_DRAG_RECT_WIDTH - 4
export const CLICK_AREA_WIDTH = 150
export const TRUNCATE_TEXT_LENGTH = 22
export const TRUNCATE_TEXT_CUTOFF = 25

export const PLAYERS_PER_MOBILE_PAGE = 3
export const NO_PLAYERS_WIDTH = 180

export const TEAM_LOGO_SIZE = 14

export const POSITION_MAP: Record<number, string> = {
    1: 'P',
    2: 'C',
    3: '1B',
    4: '2B',
    5: '3B',
    6: 'SS',
    7: 'LF',
    8: 'CF',
    9: 'RF',
    10: 'DH',
}

// STAT PICKER
export const ROW_HEIGHT = 35
export const HEADER_HEIGHT = 25
